// components/AddTagDialog.js
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  MenuItem,
  Select
} from "@mui/material";
import axios from "axios";

const AddTagDialog = ({ open, handleClose, onAdd }) => {
  const [formData, setFormData] = useState({
    name: "",
    is_visible: true,
    is_trade: false
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    const parsedValue = value === "true" ? true : value === "false" ? false : value;
    setFormData((prev) => ({ ...prev, [name]: parsedValue }));
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${process.env.REACT_APP_API_URL}/taxonomies/tags`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );
      onAdd();
      handleClose();
      setFormData({ name: "", is_visible: true, is_trade: false });
    } catch (error) {
      console.error("Error adding tag:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          fontWeight: "bold",
          backgroundColor: "#191919",
          color: "white",
          textAlign: "center",
          fontFamily: "Urbanist"
        }}
      >
        Add New Tag
      </DialogTitle>

      <DialogContent sx={{ backgroundColor: "#191919", color: "white", padding: "24px" }}>
        <FormControl fullWidth margin="normal">
          <TextField
            name="name"
            label="Nome del tag"
            variant="outlined"
            value={formData.name}
            onChange={handleInputChange}
            InputProps={{ style: { color: "white" } }}
            InputLabelProps={{ style: { color: "rgba(255,255,255,0.7)" } }}
          />
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel sx={{ color: "rgba(255,255,255,0.7)" }}>Is Visible</InputLabel>
          <Select
            name="is_visible"
            value={formData.is_visible.toString()}
            onChange={handleInputChange}
            sx={{ color: "white" }}
          >
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </FormControl>

        <FormControl fullWidth margin="normal">
          <InputLabel sx={{ color: "rgba(255,255,255,0.7)" }}>Is Trade</InputLabel>
          <Select
            name="is_trade"
            value={formData.is_trade.toString()}
            onChange={handleInputChange}
            sx={{ color: "white" }}
          >
            <MenuItem value="true">True</MenuItem>
            <MenuItem value="false">False</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ backgroundColor: "#191919", padding: "16px", justifyContent: "center" }}>
        <Button onClick={handleClose} disabled={loading} sx={{ backgroundColor: "#191919", color: "#fff", fontWeight: "bold", border: "1px solid #A3E635" }}>Cancel</Button>
        <Button onClick={handleSave} disabled={loading} sx={{ backgroundColor: "#A3E635", color: "#000", fontWeight: "bold", border: "1px solid #A3E635" }}>{loading ? "Saving..." : "Save"}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddTagDialog;
